export const METADATA_COLLAPSED_HEIGHT = 0
